import { all, fork } from 'redux-saga/effects';
import authSagas from '../views/authentication/session/auth.sagas';
import usersSagas from '../views/users/users.sagas';

// single entry point to start all Sagas at once
export default function* rootSaga() {
    yield all([
        fork(authSagas),
        fork(usersSagas)
    ]);
}
